import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  getJiraUserNotifConfig,
  setUserJiraNotifConfig,
  updateGlobalJiraNotif,
} from '../skills_action';

import { ToastContainer } from 'react-toastify';
import { Button, Switch, message, Tooltip, Radio, Input, Checkbox } from 'antd';
import { Typography, Select, Card } from 'antd';
import { ConsoleSqlOutlined, QuestionCircleOutlined } from '@ant-design/icons';

import axios from 'axios';
const { Text, Paragraph } = Typography;
const { Option } = Select;
const { Meta } = Card;

let ChannelFrequency = [
  {
    name: 'Real Time',
    value: 0,
  },
  {
    name: '1 min',
    value: 1,
  },
  {
    name: '5 min',
    value: 5,
  },
  {
    name: '15 min',
    value: 15,
  },
  {
    name: '30 min',
    value: 30,
  },
  {
    name: '1 hr',
    value: 60,
  },
  {
    name: '2 hrs',
    value: 120,
  },
  {
    name: '4 hrs',
    value: 240,
  },
  {
    name: '6 hrs',
    value: 360,
  },
  {
    name: '12 hrs',
    value: 720,
  },
];

const notifEvent = [
  {
    // label: "Updates to issues Watched by me",
    label: 'Issues watched by me',
    value: 'watched_by',
  },
  {
    // label: "Assigned to me",
    label: 'Issues assigned to me',
    value: 'assignee_self',
  },
  // {
  //   label: "@mentions",
  //   value: "mentioned_self",
  // },
  {
    label: 'Issues reported by me',
    value: 'reported_by',
  },
];

const CloseButton = ({ closeToast }) => (
  <span className='close-toaster-text' onClick={closeToast}>
    DISMISS
  </span>
);

class JiraPersonalNotification extends Component {
  defualt_configs = {
    event_type: ['mentioned_self', 'assignee_self', 'reported_by'],
    frequency: 0,
    self_actions: false,
    approval_notif: false,
    sendAsThreadedMessage: true,
    startThreadSync: true,
    // notifStatus: true,
    jiraEvents: [],
    fieldsFilter: [],
    jql: '',
    isJqlFilter: false,

    status:
      this.props.match.params.sub_skill === 'jira_service_desk' ? true : false,
    notifEvent: ['mentioned_self', 'assignee_self', 'reported_by'],
  };

  defaultState = {
    ...this.defualt_configs,
    loading: false,
    projectNotif: [],

    fieldsFilterValues: [],
    // notifFrequency: "",
    personalChannelId: '',
    error: {},
    selectedProjectName: '',
    enableUserNotif: false,
    // subskill:"jira_software",

    fields: [],
    defaultloading: false,
  };

  constructor(props) {
    super(props);
    this.state = { ...this.defaultState };
  }

  componentDidMount() {
    if (this.props.setClick)
      this.props.setClick(this.handlePersonalConfigurationdeletion);
    this.callDefaulNotifConfig();
  }

  callDefaulNotifConfig = async () => {
    let subSkill = this.props.match.params.sub_skill;
    this.setState({ loading: true });
    let res = await axios.get(
      `/bot/api/w/${this.props.match.params.wId}/jira/${this.props.match.params.skill_id}/user/${this.props.user_now._id}/field`
    );
    if (res && res.data && res.data.success)
      this.setState({ fields: res.data.items });
    let { skill } = this.props;
    let skillMeta = skill.skill_metadata
      ? skill.skill_metadata.metadata
      : skill.metadata;
    // console.log(skill)
    let config =
      subSkill === 'jira_service_desk'
        ? skillMeta.jsd_config
          ? skillMeta.jsd_config
          : this.defualt_configs
        : skillMeta.project_config
        ? skillMeta.project_config
        : this.defualt_configs;
    // console.log(config)
    if (
      this.props.skillView.view &&
      this.props.skillView.view === 'personal_preferences'
    ) {
      // console.log("i am here ",this.props.skillView)
      let userId = this.props.sConfigMember
        ? this.props.sConfigMember
        : localStorage.trooprUserId;
      let cRes = await this.props.getJiraUserNotifConfig(
        this.props.match.params.wId,
        userId,
        this.props.match.params.skill_id
      );
      if (cRes.data.success) {
        if (subSkill === 'jira_service_desk' && cRes.data.data.jsd_config) {
          config = cRes.data.data.jsd_config;
        } else if (
          subSkill === 'jira_software' &&
          cRes.data.data.project_config
        ) {
          config = cRes.data.data.project_config;
        }
        this.props.setPersonalNotifConfig(config);
      }
    }
    // console.log(config)

    if (config.fieldsFilter && config.fieldsFilter.length > 0) {
      config.fieldsFilterValues = config.fieldsFilter.map((f) => f.id);
    }
    this.setState({ ...config, loading: false });
  };
  componentDidUpdate(props) {
    //  console.log("this is update",props.jiraUserNotifConfig,this.props.jiraUserNotifConfig)

    if (
      !this.props.skillView.view ||
      this.props.skillView.view === 'connection'
    ) {
      if (this.props.match.params.sub_skill !== props.match.params.sub_skill) {
        this.callDefaulNotifConfig();
      }
    } else if (
      props.jiraUserNotifConfig.data &&
      props.jiraUserNotifConfig.data._id &&
      !(
        this.props.jiraUserNotifConfig.data &&
        this.props.jiraUserNotifConfig.data._id
      )
    ) {
      // console.log("here i am ")
      this.callDefaulNotifConfig();
    } else {
      if (this.props.botChannel != props.botChannel) {
        this.callDefaulNotifConfig();
      }
    }
  }
  handlePersonalConfigurationdeletion = () => {
    let data = {
      notifEvent: this.defualt_configs.event_type,
      status: this.props.skill.enableUserNotif,
    };

    this.setState({ ...data });
  };

  toggleNotif = () => {
    this.setState({ status: !this.state.status }, () => this.onSave());
  };
  changeFilterType = (e) => {
    this.setState({
      isJqlFilter: e.target.value,
    });
  };
  onChangeProject = (e) => {
    const index = e.nativeEvent.target.selectedIndex;
    const text = e.nativeEvent.target[index].text;
    this.setState({
      [e.target.name]: e.target.value,
      selectedProjectName: text,
    });
  };

  onChangeEvent = (e) => {
    if (this.state.notifEvent) {
      let arr = this.state.notifEvent;
      let index = arr.findIndex((item) => item === e.target.value);
      if (index > -1) {
        arr.splice(index, 1);
      } else {
        arr.push(e.target.value);
      }
      this.setState({ [e.target.name]: arr }, () => {});
    }
  };

  onChangeFrequency = (event, value) => {
    this.setState(
      {
        frequency: event,
      },
      () => {}
    );
    if (event !== 0) {
      this.setState({
        startThreadSync: false,
      });
    }
  };

  threadedMessagesChangeHandler = (e) => {
    let newStatus = e === 'true';
    this.setState({
      sendAsThreadedMessage: newStatus,
    });
  };

  threadSyncStatusChangeHandler = (e) => {
    this.setState({
      startThreadSync: e,
    });
  };
  onJqlChange = (e) => {
    this.setState({ jql: e.target.value });
  };
  event = (val) => {
    let eventsTypes = [];

    let index = this.state.event_type.findIndex((e) => e === 'mentioned_self');

    if (index > -1) {
      val.push('mentioned_self');
    }

    this.setState({ event_type: val, notifEvent: val });
  };

  addMentionEvent = () => {
    let _arr = [...this.state.event_type];
    let index = _arr.findIndex((e) => e === 'mentioned_self');
    if (index > -1) {
      _arr.splice(index, 1);
    } else {
      _arr.push('mentioned_self');
    }
    this.setState({ event_type: _arr });
  };

  onjiraEventChange = (val) => {
    this.setState({ jiraEvents: val });
  };
  onjiraFieldChange = (val, field) => {
    let fields = field.map((f) => ({
      name: f.children,
      key: f.key,
      id: f.value,
    }));

    this.setState({ fieldsFilter: fields, fieldsFilterValues: val });
  };

  toggleSelfEvent = () => {
    this.setState({ self_actions: !this.state.self_actions }, () => {});
  };
  toggleApproval = () => {
    this.setState({ approval_notif: !this.state.approval_notif }, () => {});
  };
  onSave = async () => {
    let { jiraUserNotifConfig, skill } = this.props;

    this.setState({ defaultloading: true });
    let skillMeta = skill.skill_metadata
      ? skill.skill_metadata.metadata
      : skill.metadata;

    jiraUserNotifConfig = jiraUserNotifConfig ? jiraUserNotifConfig.data : null;
    let configs = {
      event_type: this.state.event_type,
      frequency: this.state.frequency,
      self_actions: this.state.self_actions,
      approval_notif: this.state.approval_notif,
      jiraEvents: this.state.jiraEvents,
      fieldsFilter: this.state.jiraEvents.find(
        (e) => e === 'jira:issue_updated'
      )
        ? this.state.fieldsFilter
        : [],
      sendAsThreadedMessage: this.state.sendAsThreadedMessage,
      startThreadSync: this.state.startThreadSync,
      status: this.state.status,
      isJqlFilter: this.state.isJqlFilter,

      jql: this.state.jql,
    };

    if (configs.fieldsFilter.length == 0) {
      this.setState({ fieldsFilter: [], fieldsFilterValues: [] });
    }

    let _obj = {};

    if (this.props.match.params.sub_skill === 'jira_service_desk') {
      if (!(jiraUserNotifConfig && jiraUserNotifConfig._id)) {
        // default_values.status=false

        _obj.project_config = skillMeta.project_config
          ? skillMeta.project_config
          : this.defualt_configs;
      }

      _obj.jsd_config = configs;
    } else {
      _obj.project_config = configs;
      if (!(jiraUserNotifConfig && jiraUserNotifConfig.jsd_config))
        _obj.jsd_config = skillMeta.jsd_config
          ? skillMeta.jsd_config
          : this.defualt_configs;
    }

    // let events = this.state.event_type;
    // if (events.length === 0 || this.state.status) {
    //   message.error('Please select issue filter(s)');
    //   this.setState({ defaultloading: false });
    //   return;
    // }
    let savedConfig = '';

    if (
      this.props.skillView.view &&
      this.props.skillView.view === 'personal_preferences'
    ) {
      let data = {
        user_id: this.props.sConfigMember
          ? this.props.sConfigMember
          : localStorage.trooprUserId,
        workspace_id: this.props.match.params.wId,
        channel_id: this.props.botChannel,
        account_id: this.props.sConfigMember
          ? this.props.accountId
          : this.props.currentSkillUser.user_obj.accountId,
        is_bot_channel: true,
        skill_id: this.props.match.params.skill_id,
      };
      data = { ...data, ..._obj };
      savedConfig = await this.props.setUserJiraNotifConfig(
        this.props.match.params.wId,
        this.props.match.params.skill_id,
        data
      );
    } else {
      savedConfig = await this.props.updateGlobalJiraNotif(
        this.props.match.params.wId,
        this.props.match.params.skill_id,
        _obj
      );
    }

    // let savedConfig= this.props.setUserJiraNotifConfig(this.props.match.params.wId, this.props.match.params.skill_id, data)

    this.setState({ defaultloading: false });
    if (!savedConfig.data.success) {
      let errMessage = 'Error while saving notification config.';
      if (savedConfig.data.error && savedConfig.data.error.type) {
        errMessage = savedConfig.data.error.message;
      }
      message.error(errMessage);
    } else {
      // this.setState({ defaultloading: false });
      message.success('Saved successfully');
    }
  };

  toggleOn = () => {
    this.setState({
      enableUserNotif: false,
    });
  };

  toggleOff = () => {
    this.setState({
      enableUserNotif: true,
    });
  };

  getTitle = () => {
    return this.props.skillView.view &&
      this.props.skillView.view === 'personal_preferences'
      ? 'Personal Notifications'
      : 'Default personal notifications for team members';
  };

  getJiraEvent = (subSkill) => {
    const commonEvents = [
      {
        label: 'Comment is added',
        value: 'comment_created',
      },
      {
        label: 'Comment is updated',
        value: 'comment_updated',
      },
    ];

    const jiraSoftwareEvents = [
      {
        label: 'Issue is created',
        value: 'jira:issue_created',
      },
      {
        label: 'Issue is updated',
        value: 'jira:issue_updated',
      },
      ...commonEvents,
    ];

    const jiraServiceDeskEvents = [
      {
        label: 'Request is created',
        value: 'jira:issue_created',
      },
      {
        label: 'Request is updated',
        value: 'jira:issue_updated',
      },
      ...commonEvents,
    ];

    return subSkill === 'jira_software'
      ? jiraSoftwareEvents
      : jiraServiceDeskEvents;
  };

  render() {
    const tooltipIcon = <QuestionCircleOutlined style={{ marginLeft: 5 }} />;
    return (
      <Card
        title={this.getTitle()}
        loading={this.state.loading}
        extra={
          <Switch checked={this.state.status} onClick={this.toggleNotif} />
        }
      >
        {(!this.props.skillView.view ||
          this.props.skillView.view === 'connection') && (
          <div style={{ marginBottom: 16 }}>
            <Text type='secondary'>
              This configuration will be used to deliver relevant personal
              notifications for workspace members until they customize their own
              personal notification preferences. This is applicable to all Slack
              users who are mapped to their corresponding Jira accounts by
              Troopr.
            </Text>
          </div>
        )}
        <div style={{ marginBottom: 16 }}>
          <Text type='secondary'>
            Notifications about Jira{' '}
            {this.props.match.params.sub_skill === 'jira_service_desk'
              ? 'request'
              : 'issue'}{' '}
            updates will be delivered privately in "Troopr Assistant" channel.
          </Text>
        </div>

        {this.state.error.projectNotif && (
          <div className='error_message'>{this.state.error.projectNotif}</div>
        )}

        <Card style={{ marginBottom: 16 }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginBottom: 16,
            }}
          >
            <Text type='secondary' strong>
              Send notification only for these issues
            </Text>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',

              alignItems: 'center',
            }}
          >
            <div>
              <div style={{ marginRight: 8 }}>
                <Text>Filter condition:</Text>
              </div>
            </div>

            {!(
              this.props.match.params.sub_skill === 'jira_service_desk' &&
              this.props.skillView.view === 'connection'
            ) ? (
              this.props.skillView.view === 'personal_preferences' &&
              this.props.match.params.sub_skill === 'jira_service_desk' ? (
                this.props.currentSkillUser &&
                this.props.currentSkillUser.token_obj &&
                this.props.currentSkillUser.token_obj && (
                  <div>
                    <Radio.Group
                      disabled={!this.state.status}
                      onChange={this.changeFilterType}
                      value={this.state.isJqlFilter}
                    >
                      <Radio value={false}>Pre-built filter</Radio>
                      <Radio value={true}>JQL filter</Radio>
                    </Radio.Group>
                  </div>
                )
              ) : (
                <div>
                  <Radio.Group
                    disabled={!this.state.status}
                    onChange={this.changeFilterType}
                    value={this.state.isJqlFilter}
                  >
                    <Radio value={false}>Pre-built filter</Radio>
                    <Radio value={true}>JQL filter</Radio>
                  </Radio.Group>
                </div>
              )
            ) : (
              <></>
            )}
          </div>

          {this.state.isJqlFilter ? (
            // && this.props.match.params.sub_skill === 'jira_software'
            <Input
              name='jql'
              defaultValue={this.state.jql}
              placeholder='write JQL query here'
              onChange={this.onJqlChange}
              style={{ width: 600, marginTop: '1rem' }}
            />
          ) : (
            <>
              <div
                style={{
                  marginBottom: 8,
                }}
              >
                <Checkbox
                  disabled={!this.state.status}
                  checked={this.state.event_type.find(
                    (i) => i === 'mentioned_self'
                  )}
                  onChange={this.addMentionEvent}
                >
                  Always send updates where I am mentioned
                </Checkbox>
              </div>

              <div>
                <Select
                  disabled={!this.state.status}
                  name='projectNotif'
                  style={{ width: 600 }}
                  value={this.state.event_type.filter(
                    (ev) => ev !== 'mentioned_self'
                  )}
                  placeholder='Select issue filter(s)'
                  onChange={this.event}
                  mode='multiple'
                >
                  {notifEvent.map((event, i) => (
                    <Option key={i} value={event.value}>
                      {event.label}
                    </Option>
                  ))}
                </Select>
              </div>
            </>
          )}
        </Card>
        {/* {this.props.match.params.sub_skill === 'jira_software' && ( */}
        <Card style={{ marginBottom: 16 }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              // backgroundColor: '#efefef',
            }}
          >
            <div
              style={{
                marginBottom: 16,
              }}
            >
              <Text strong type='secondary'>
                Send notification only for these updates (optional)
              </Text>
            </div>

            <Select
              disabled={!this.state.status}
              name='jiraEvents'
              style={{ width: 600 }}
              value={this.state.jiraEvents}
              placeholder='Defaults to all updates. Click to choose.'
              onChange={this.onjiraEventChange}
              mode='multiple'
            >
              {this.getJiraEvent(this.props.match.params.sub_skill).map(
                (event, i) => (
                  <Option key={i} value={event.value}>
                    {event.label}
                  </Option>
                )
              )}
            </Select>

            {this.state.jiraEvents.find((e) => e === 'jira:issue_updated') && (
              <div style={{ marginBottom: 16 }}>
                <div>
                  <Text type='secondary'>
                    and there is a update to these fields (optional)
                  </Text>
                </div>
                <div>
                  <Select
                    disabled={!this.state.status}
                    name='fieldsFilter'
                    style={{ width: 600 }}
                    value={this.state.fieldsFilterValues}
                    placeholder='Defaults to all updates. Click to choose.'
                    showSearch
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(e, field) => this.onjiraFieldChange(e, field)}
                    mode='multiple'
                  >
                    {this.state.fields
                      .filter(
                        (f) =>
                          f.id !== 'comment' &&
                          f.id !== 'worklog' &&
                          f.id !== 'issuelinks' &&
                          f.id !== 'watches'
                      )
                      .map((event, i) => (
                        <Option key={event.key} value={event.id}>
                          {event.name}
                        </Option>
                      ))}
                  </Select>
                </div>
              </div>
            )}
          </div>
        </Card>
        {/* )} */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            marginBottom: 16,
          }}
        >
          {/* <div style={{ display: "flex", flexDirection: "row", marginBottom: 16, width: "50%" }}> */}
          <div style={{ marginRight: 16 }}>
            <div>
              <Text type='secondary'>
                Display Format
                <Tooltip title='Compact format shows limited information in the main message. Both formats show additional details in thread'>
                  {tooltipIcon}
                </Tooltip>
              </Text>
            </div>
            <Select
              style={{ width: 200, marginRight: 8 }}
              placeholder='Please select'
              // defaultValue={this.state.sendAsThreadedMessage.toString()}
              value={this.state.sendAsThreadedMessage.toString()}
              onChange={this.threadedMessagesChangeHandler}
              disabled={!this.state.status}
            >
              <Option key='true'>Compact</Option>
              <Option key='false'>Standard</Option>
            </Select>
          </div>

          {this.props.workspace && this.props.workspace.is_enterprise && (
            <div style={{ marginRight: 16 }}>
              {/* <Text type="secondary">Frequency</Text> */}
              <div>
                <Text type='secondary'>
                  Delivery Frequency
                  <Tooltip title='You can delay notification delivery. All notifications in the selected time interval will be grouped. Choose realtime to deliver without delay.'>
                    {tooltipIcon}
                  </Tooltip>
                </Text>{' '}
              </div>
              <div>
                <Select
                  disabled={
                    !this.state.status ||
                    !this.props.skillView.view ||
                    (this.props.skillView.view &&
                      this.props.skillView.view === 'connection')
                  }
                  name='projectNotif'
                  style={{ width: 200, marginRight: 16 }}
                  value={this.state.frequency}
                  placeholder='Select Frequency'
                  onChange={this.onChangeFrequency}
                >
                  {ChannelFrequency.map((project, index) => (
                    <Option key={project.value} value={project.value}>
                      {project.name}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
          )}
          {this.props.workspace && this.props.workspace.is_enterprise && (
            <div style={{ marginRight: 16 }}>
              {/* <Text type="secondary">Frequency</Text> */}
              <div>
                <Text type='secondary'>
                  Start Thread Sync
                  <Tooltip title='Start or enable notification message thread to continuously sync with the corresponding Jira issue.'>
                    {tooltipIcon}
                  </Tooltip>
                </Text>{' '}
              </div>

              <div>
                <Switch
                  disabled={!this.state.status || this.state.frequency !== 0}
                  checked={this.state.startThreadSync}
                  onChange={this.threadSyncStatusChangeHandler}
                />
              </div>

              {/* </Select> */}
            </div>
          )}
        </div>

        <div style={{ marginBottom: 16 }}>
          <Checkbox
            disabled={!this.state.status}
            checked={this.state.self_actions}
            onChange={() => this.toggleSelfEvent()}
          >
            Send notifications for actions taken by self
          </Checkbox>
        </div>
        {this.props.match.params.sub_skill === 'jira_service_desk' && (
          <div style={{ marginBottom: 16 }}>
            <Checkbox
              disabled={!this.state.status}
              checked={this.state.approval_notif}
              onChange={() => this.toggleApproval()}
            >
              Send notifications for approvals
            </Checkbox>
          </div>
        )}
        <div>
          <Button
            loading={this.state.defaultloading}
            onClick={this.onSave}
            disabled={!this.state.status}
          >
            Save
          </Button>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentSkillUser: state.skills.currentSkillUser,
    assistant_skills: state.skills,
    workspace: state.skills.workspace,
    jiraUserNotifConfig: state.skills.jiraUserNotifConfig,
    user_now: state.common_reducer.user,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    updateGlobalJiraNotif,
    getJiraUserNotifConfig,
    setUserJiraNotifConfig,
  })(JiraPersonalNotification)
);
